import { render, staticRenderFns } from "./CandidateWizardSignIn.vue?vue&type=template&id=70e1c97a&"
import script from "./CandidateWizardSignIn.vue?vue&type=script&lang=js&"
export * from "./CandidateWizardSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports